// Google Translate (English mode) rewraps text nodes in <font>; React then throws on removeChild/insertBefore
// and unmounts the whole tree (black page). Tolerate the mismatch instead (facebook/react#11538 workaround).
if (typeof Node === "function" && Node.prototype) {
  const origRemove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) return child;
    return origRemove.apply(this, arguments);
  };
  const origInsert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, ref) {
    if (ref && ref.parentNode !== this) return origInsert.call(this, newNode, null);
    return origInsert.apply(this, arguments);
  };
}
